module.exports = __webpack_public_path__ + "static/bugtracking_full_homepage-b83f8c51bbf821002000ac240336b5e1.png";